namespace Matrix.Workflow {
    export interface QueueFieldForm {
        FieldName: QueueFieldNameEditor;
        DisplayName: Serenity.StringEditor;
        IsRequired: Serenity.BooleanEditor;
        Updatable: Serenity.BooleanEditor;
        VisibleInForm: Serenity.BooleanEditor;
        FormTab: Serenity.StringEditor;
        FormCategory: Serenity.StringEditor;
        FormWidth: Data.FormWidthEditor;
        FormWidthUntilNext: Serenity.BooleanEditor;
        FormWidthJustThis: Serenity.BooleanEditor;
        LabelWidth: Serenity.StringEditor;
        LabelWidthUntilNext: Serenity.BooleanEditor;
        LabelWidthJustThis: Serenity.BooleanEditor;
        MaxLength: Serenity.IntegerEditor;
        DecimalPlaces: Serenity.IntegerEditor;
        DateTimeKind: Serenity.IntegerEditor;
        EditorType: Serenity.LookupEditor;
        VisibleInGrid: Serenity.BooleanEditor;
        EditLink: Serenity.BooleanEditor;
        Width: Serenity.IntegerEditor;
        Alignment: Data.AlignmentStringEditor;
        QuickSearchType: Serenity.EnumEditor;
        DisplayFormat: Serenity.StringEditor;
        FormatterType: Serenity.LookupEditor;
        SortOrder: Serenity.IntegerEditor;
        GroupOrder: Serenity.IntegerEditor;
        SummaryType: Serenity.IntegerEditor;
        ReadPermission: Serenity.StringEditor;
        ModifyPermission: Serenity.StringEditor;
    }

    export class QueueFieldForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.QueueField';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QueueFieldForm.init)  {
                QueueFieldForm.init = true;

                var s = Serenity;
                var w0 = QueueFieldNameEditor;
                var w1 = s.StringEditor;
                var w2 = s.BooleanEditor;
                var w3 = Data.FormWidthEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.LookupEditor;
                var w6 = Data.AlignmentStringEditor;
                var w7 = s.EnumEditor;

                Q.initFormType(QueueFieldForm, [
                    'FieldName', w0,
                    'DisplayName', w1,
                    'IsRequired', w2,
                    'Updatable', w2,
                    'VisibleInForm', w2,
                    'FormTab', w1,
                    'FormCategory', w1,
                    'FormWidth', w3,
                    'FormWidthUntilNext', w2,
                    'FormWidthJustThis', w2,
                    'LabelWidth', w1,
                    'LabelWidthUntilNext', w2,
                    'LabelWidthJustThis', w2,
                    'MaxLength', w4,
                    'DecimalPlaces', w4,
                    'DateTimeKind', w4,
                    'EditorType', w5,
                    'VisibleInGrid', w2,
                    'EditLink', w2,
                    'Width', w4,
                    'Alignment', w6,
                    'QuickSearchType', w7,
                    'DisplayFormat', w1,
                    'FormatterType', w5,
                    'SortOrder', w4,
                    'GroupOrder', w4,
                    'SummaryType', w4,
                    'ReadPermission', w1,
                    'ModifyPermission', w1
                ]);
            }
        }
    }
}
